module.exports = __webpack_public_path__ + "static/media/info.354c285e.svg";